import type {
  UpdateCompanySettingsPayload,
  UpdateCompanySettingsResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import {
  zodCompanySettingsSchema,
  zodUpdateCompanySettingsBodySchema,
  zodUpdateCompanySettingsEndpointSchema,
} from './validations';

/**
 * Updates a company's settings.
 *
 * @deprecated This endpoint is deprecated and shall be replaced by update_company_by_id.
 * @param companyId - The ID of the company to update.
 * @param settings - An object containing the settings to be updated.
 * @returns A promise that resolves with the API response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/update_vadmin_settings_vadmin_company__company_id__vadmin_settings_post
 */
export const updateCompanySettings = async (
  companyId: UUID,
  settings: UpdateCompanySettingsPayload,
) => {
  const response = await vestigasApi
    .post(ENDPOINT.COMPANY.SETTINGS.UPDATE(companyId), {
      json: settings,
      validate: {
        body: zodUpdateCompanySettingsBodySchema,
        pathSegments: zodUpdateCompanySettingsEndpointSchema,
        response: zodCompanySettingsSchema,
      },
    })
    .json<UpdateCompanySettingsResponse>();

  return response;
};
